export function magnifyingGlassEffect(options) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("v_animated_icon_show");
      }
    });
  }, options);

  const elements = document.querySelectorAll(".v_animated_icon_blur");
  if (elements) {
    Array.from(elements).forEach((element) => {
      observer.observe(element);
    });
  }
}
